<p-menu #menu [popup]="true" [model]="items"></p-menu>

<button
  pButton
  pRipple
  type="button"
  icon="pi pi-bell"
  (click)="menu.toggle($event)"
  class="p-button-rounded p-button-secondary p-button-text"
></button>
